import { RICH_MEDIA_QUILL_TOOLBAR } from '@shared/consts/rich-media-quill.const';

export const MailingQuillModules = () => {
  return {
    toolbar: RICH_MEDIA_QUILL_TOOLBAR
  };
};
